import { createUseContext } from '@boxcryptor-web/shared/react-hooks';
import * as React from 'react';

export type LinkIdContext = {
  idPrefix?: string;
};

const LinkIdContext = React.createContext<LinkIdContext>({});

export const useLinkIdContext = createUseContext('LinkIdContext', LinkIdContext);

export const LinkIdContextProvider = LinkIdContext.Provider;
